<style type="text/scss" lang="scss">
  input {
    padding: 12px 12px 12px 4px;
    width: 100%;
    margin: 12px 0;
    background: transparent;
    border-bottom: 1px solid #e4e3e3;
    border-top: none;
    border-left: none;
    border-right: none;
    font-family: proxima-nova, sans-serif;
    font-weight: 300;
    color: #4c4c4b;
    font-size: 20px;
    line-height: 21.034px;

    transition: border 0.3s;

    &::placeholder {
      color: #9c9c9c;
    }
  }

  input:focus {
    outline: none !important;
    border-bottom: 1px solid #4c4c4b;
  }
</style>

<script>
  import { createEventDispatcher } from 'svelte';
  export let placeholder;
  export let value = '';

  const dispatch = createEventDispatcher();

  const onInput = (e) => dispatch('input', e);

</script>

<input placeholder={placeholder} on:input={onInput} bind:value={value} />